<template>
        <!-- Hero Start -->
        <section class="bg-auth-home d-table w-100">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-7 col-md-6">
                        <div class="me-lg-5">
                            <img src="assets/images/user/signup.svg" class="img-fluid d-block mx-auto" alt="">
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-6">
                        <div class="card shadow rounded border-0">
                            <div class="card-body">
                                <h4 class="card-title text-center">Sign Up</h4>
                                <form class="login-form mt-4" @submit.prevent="register()">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div  v-if="error !== null" class="mb-3 alert alert-danger alert-dismissible fade show" role="alert">
                                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                                <strong>{{ error }}</strong>
                                            </div>

                                            <div class="mb-3">
                                                <label class="form-label">Name</label>
                                                <input type="text" class="form-control" id="login-name" v-model="user.name" required>
                                            </div>

                                            <div class="mb-3">
                                                <label class="form-label">Phone number</label>
                                                <input type="tel" class="form-control" id="login-mobile" placeholder="" v-model="user.mobile" dir="ltr" required>
                                            </div>

                                            <div class="mb-3">
                                                <label class="form-label">Email</label>
                                                <input type="email" class="form-control" id="login-email" v-model="user.email" required>
                                            </div>

                                            <div class="mb-3">
                                                <label class="form-label">Password</label>
                                                <input type="password" class="form-control" id="login-password" v-model="user.password" required>
                                            </div>

                                            <div class="mb-3">
                                                <label class="form-label">Password Confirm</label>
                                                <input type="password" class="form-control" id="login-password-confirm" v-model="user.password_confirm" required>
                                            </div>

                                            <div class="d-grid mb-3">
                                                <button class="btn btn-primary" type="submit">Sign Up</button>
                                            </div>

                                            <div class="mt-4 text-center">
                                                <router-link :to="{ name:'login' }" class="btn btn-secondary">
                                                    Log In
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> <!--end col-->
                </div><!--end row-->
            </div> <!--end container-->
        </section><!--end section-->
        <!-- Hero End -->
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    props: ['main'],
    inject: ['auth'],
    data() {
        return {
            user: {
                agree: false
            },
            error: null,
            validationErrors: null
        };
    },
    methods: {
        register() {
            const that = this;
            this.validationErrors = null;
            const id = toast.info('Registration in progress.', );

            this.auth.register({
                data: this.user,
                on_success: function (response) {
                    toast.dismiss(id);
                    toast.success(response.data.message, {
                        timeout: 3000
                    });
                    that.error = null;
                    that.user = {};
                    that.$router.push({ name: 'activation' });
                    // that.$router.push({ name: 'home' });

                },
                on_fail: function (message, response) {
                    that.error = message;
                    if (response) {
                        that.validationErrors = response.data.errors;
                    }
                },
                on_completed: function () {
                    toast.dismiss(id);
                }
            });
        }
    }
}
</script>
